<template>
    <div class="magazine-order-info-container ">
        <div class="magazine-card middle-main">
            <div :class="['magazine-card-content', { 'flex-col': isPc == 3 }]">
                <div class="magazine-img">
                    <img class="magazine-img-item" v-for="item in magazineList" :key="item.id" :src="item.image"
                        alt="magazine-order-info">
                </div>
                <div class="magazine-order-info">
                    <img class="ts-icon" src="@/assets/images/ts-icon.png" alt="magazine-order-info">
                    <h3>歡迎訂閱《台商》月刊</h3>
                    <p>《台商》月刊於2004年1月創刊，是兩岸四地唯一同步發行、同一版本的期刊，每月五日出版。<br>
                        2024年5月，《台商》雜誌重新定義，改版焕新。《台商》雜誌聚焦兩岸政經話題，探索商業產業脈絡，邀約台灣權威專家、學者撰稿，原味真實呈現台灣全方位生態。</p>
                    <div class="magazine-order-info-contact">联系邮箱: TS960@vip.163.com</div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { mapState } from "vuex";
export default {
    name: 'MagazineOrderInfo',
    props: {
        magazineList: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState(["isPc"]),
    },
    methods: {
        toOrder() {
            this.$router.push('/order');
        }
    }
}
</script>

<style lang="less" scoped>
.magazine-order-info-container {
    background: #202020;
    padding: 40px;
    position: relative;

    .ts-icon {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        transform: rotate(-10deg);
        margin-bottom: 10px;
    }

    .magazine-card {
        width: 100%;
        height: 100%;
        padding: 6px;
        position: relative;
        border-radius: 16px;
        justify-content: center;
        align-items: center;
        text-align: center;
        display: flex;
        font-size: 1.5em;
        color: rgba(88, 199, 250, 0);
        // cursor: pointer;
        font-family: cursive;
    }

    .magazine-card:hover {
        color: rgba(88, 199, 250, 1);
        transition: color 1s;
    }


    .magazine-card-content {
        background: #191c29;
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
        border-radius: 16px;
        padding: 24px;

        .magazine-img {
            width: 280px;
            height: 290px;
            margin-right: 40px;
            position: relative;

            .magazine-img-item {
                position: absolute;
                top: 0%;
                left: 50%;
                width: 190px;
                height: auto;
                box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.65);
                border-radius: 4px;
                transform: rotate(0deg) translateX(-50%);
            }

            .magazine-img-item:nth-child(1) {
                top: 0;
                left: 37%;
                transform: rotate(-10deg) translateX(-50%);

            }

            .magazine-img-item:nth-child(2) {
                transform: rotate(-2deg) translateX(-50%);
            }

            .magazine-img-item:nth-child(3) {
                top: 35px;
                left: 66%;
                transform: rotate(5deg) translateX(-50%);

            }
        }

        .magazine-order-info {
            flex: 1;
            display: flex;
            flex-direction: column;

            h3 {
                font-family: SourceHanSerifCN, SourceHanSerifCN;
                font-weight: 800;
                font-size: 32px;
                color: #FFFFFF;
                line-height: 46px;
                text-align: left;
                font-style: normal;
                margin-bottom: 12px;
            }

            p {
                font-family: SourceHanSerifCN, SourceHanSerifCN;
                font-weight: 800;
                font-size: 18px;
                color: rgba(255, 255, 255, 0.6);
                line-height: 26px;
                text-align: left;
                font-style: normal;
                margin-bottom: 24px;
            }

            .magazine-order-info-contact {
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: rgba(255, 255, 255, 0.4);
                line-height: 16px;
                letter-spacing: 1px;
                text-align: left;
                font-style: normal;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .magazine-order-info-container {
        background: #202020;
        padding: 60px 40px;
        position: relative;

        .ts-icon {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            transform: rotate(-10deg);
            margin-bottom: 16px;
        }

        .magazine-card {
            width: 100%;
            height: 100%;
            padding: 6px;
            position: relative;
            border-radius: 16px;
            justify-content: center;
            align-items: center;
            text-align: center;
            display: flex;
            font-size: 1.5em;
            color: rgba(88, 199, 250, 0);
            // cursor: pointer;
            font-family: cursive;
        }

        .magazine-card:hover {
            color: rgba(88, 199, 250, 1);
            transition: color 1s;
        }


        .magazine-card-content {
            background: #191c29;
            width: 100%;
            height: 100%;
            display: flex;
            position: relative;
            border-radius: 0;
            padding: 0;

            .magazine-img {
                width: 280px;
                height: 290px;
                margin-right: 0;
                position: relative;

                .magazine-img-item {
                    position: absolute;
                    top: 0%;
                    left: 50%;
                    width: 190px;
                    height: auto;
                    box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.65);
                    border-radius: 4px;
                    transform: rotate(0deg) translateX(-50%);
                }

                .magazine-img-item:nth-child(1) {
                    top: 0;
                    left: 37%;
                    transform: rotate(-10deg) translateX(-50%);

                }

                .magazine-img-item:nth-child(2) {
                    transform: rotate(-2deg) translateX(-50%);
                }

                .magazine-img-item:nth-child(3) {
                    top: 35px;
                    left: 66%;
                    transform: rotate(5deg) translateX(-50%);

                }
            }

            .magazine-order-info {
                flex: 1;
                display: flex;
                flex-direction: column;
                position: relative;
                margin-top: -71px;

                h3 {
                    font-family: SourceHanSerifCN, SourceHanSerifCN;
                    font-weight: 800;
                    font-size: 24px;
                    color: #FFFFFF;
                    line-height: 35px;
                    text-align: left;
                    font-style: normal;
                    margin-bottom: 12px;
                }

                p {
                    font-family: SourceHanSerifCN, SourceHanSerifCN;
                    font-weight: 800;
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.6);
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                    margin-bottom: 20px;
                }

                .magazine-order-info-contact {
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.4);
                    line-height: 16px;
                    letter-spacing: 1px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/common/magazine-order-info-black.vue